import React,{useEffect,useState} from 'react'
import TextField from '../../components/TextField'
import SubmitButton from '../../components/SubmitButton'
import {Error, Success} from '../../components/Status'
import {useCreateRole} from '../../hooks/roles/useCreate'
import {useGetPrivileges} from '../../hooks/users/useGet'

import Select from '../../components/Select'


const CreateRole = () => {
    // STATES
    // PAYLOAD STATE
    const [state,setState]=useState({
        roleName:"",
        privilegeId:0
    })
    // MISC STATE
    const [error,setError]=useState("")
    const [success,setSuccess]=useState("")

    // MISC DATA
    const {data:privileges,isSuccess:gotPrivileges}=useGetPrivileges()
    const selectOptions=privileges?.map(item=>({name:`${item.privilegeName} (${item.description})`,value:item.privilegeId}))

    // MUTATION
    const {mutate:createRole,error:createError,isLoading,isSuccess}=useCreateRole(state)
    
    // HANDLERS
    // INPUT HANDLER
    const handleChange=({target:{name,value}})=>{
            setState({...state,[name]:value})
    }

    // SUBMIT HANDLER
    const handleSubmit=(e)=>{
        e.preventDefault();
        // REFRESH ERROR
        setError('')
        createRole()
    }

    // EFFECTS
    useEffect(()=>{
        if(isSuccess){
            setSuccess("Role created successfully")
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
    },[isSuccess])

    useEffect(()=>{
        if(createError){
            const message=createError?.response?.data?.message
            setError(message)
        }
    },[createError])

    return (
        <form className='w-full flex flex-col space-y-5' onSubmit={handleSubmit}>
            {success.length>0&&<Success>{success}</Success>}
            {error.length>0&&<Error>{error}</Error>}
            <TextField label='Role Name' required name='roleName' value={state.roleName} onChange={handleChange} />
            {gotPrivileges&&<Select name='privilegeId' onChange={handleChange} placeholder="Select an option" label='Privilege' options={selectOptions} required/>}
            <SubmitButton loading={isLoading}>Submit</SubmitButton>
        </form>
    )
}

export default CreateRole
